/* eslint-disable react/prop-types */
import React from 'react';

const SIGNAL_LABEL = {
  workload_depth:            'Workload depth',
  follow_up_carry_weight:    'Follow-Up Carry Weight™',
  depth_consistency:         'Depth consistency',
  weekend_bleed:             'Weekend / after-hours',
  recovery_rhythm:           'Recovery rhythm',
  emotional_dependency_load: 'Emotional dependency load',
  reflective_space:          'Reflective Space Compression™',
};

/**
 * 7 calm horizontal bars. No "score" labels, no big numbers.
 * Healthy = high; muted, not green-grading.
 */
export default function SignalGrid({ signals, raw, compact = false }) {
  if (!signals) return null;
  return (
    <ul data-testid="sustainability-signal-grid"
        className={`space-y-2 ${compact ? '' : 'mt-2'}`}>
      {Object.entries(signals).map(([key, value]) => (
        <li key={key} data-testid={`signal-row-${key}`}
            className="flex items-center gap-2">
          <span className="text-[10px] uppercase tracking-[0.14em] text-[#8A8681] w-56 truncate">
            {SIGNAL_LABEL[key] || key}
          </span>
          <div className="flex-1 h-1 rounded-full bg-[#F4F2EE] overflow-hidden">
            <div
              className="h-full"
              style={{
                width: `${Math.min(100, value || 0)}%`,
                background:
                  value >= 75 ? '#4A5D4E' :
                  value >= 55 ? '#7A8A8C' :
                  value >= 35 ? '#C8A368' :
                                '#A8A29E',
              }}
            />
          </div>
          <span className="text-[10px] tabular-nums text-[#8A8681] w-9 text-right">
            {value ?? '—'}
          </span>
        </li>
      ))}
      {raw && !compact && (
        <li data-testid="signal-raw-inputs"
            className="text-[10px] text-[#B5B0A8] italic pt-1.5">
          {raw.total_log_count} logs · {raw.events_in_window} events ·
          {' '}{raw.off_days_in_21d}d off / 21d ·
          {' '}{raw.high_dependency_lead_count} high-dependency leads
        </li>
      )}
    </ul>
  );
}
